function isBookingWidgetPresent() {
  const widget = document.querySelector(
    'iframe[name="opentable-make-reservation-widget"]'
  );
  const bookingWidgetPresent = !!widget;

  if (bookingWidgetPresent) {
    detectWidgetInteractions();
  }
}

function detectWidgetInteractions() {
  // Detect modal opening
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.id === 'ot-cfe-modal') {
          gtmBookingInteraction();
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
  });
}

function gtmBookingInteraction() {
  const triggerName = 'olive_find_a_table';
  const pushData = {};
  if (typeof dataLayer !== 'undefined') {
    gtag('event', triggerName, pushData);
    console.log('trigger: ' + triggerName);
  }
}

window.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    isBookingWidgetPresent();
  }, 2000);
});

// track all link clicks with opentable in the url
document.addEventListener('click', function (event) {
  const link = event.target.closest('a');
  if (link) {
    const targetHref = link.href;
    if (targetHref.includes('opentable.com.au')) {
      gtmBookingInteraction();
    }
  }
});
